import Links from './components/Links';
import routes from 'routes.js';
import './sidebar.css';
import { useSidebar } from 'hooks/UseSideBar';

const Sidebar = ({}) => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <div className={`sidebar-wrapper${isCollapsed ? ' collapsed' : ''}`}>
      {/* ── Brand header ──────────────────────────────── */}
      <div className="sidebar-brand font-poppins font-bold uppercase text-green-500 bg-green-50">
        <span onClick={toggleSidebar} className="cursor-pointer flex-shrink-0">
          <img src="/assets/img/logo.png" alt="logo-image" width={44} />
        </span>

        <span className={`sidebar-brand-text${isCollapsed ? ' collapsed' : ''}`}>
          FNTEC-<span className="font-normal text-sm">MINEFOP</span>
        </span>

        {/* <IconButton
          onClick={toggleSidebar}
          className={`sidebar-toggle-btn${isCollapsed ? ' collapsed' : ''}`}
          size="small"
          color="warning"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <BsArrowLeftCircleFill />
        </IconButton> */}
      </div>

      <hr />

      {/* ── Navigation links ──────────────────────────── */}
      <ul className="sidebar mb-auto pt-1 mt-[10px]">
        <Links routes={routes} />
      </ul>
    </div>
  );
};

export default Sidebar;
